export default __webpack_public_path__ + "static/media/warning--falling-rocks-or-debris-right--g4.84a6e30d.png";